import { render, staticRenderFns } from "./leftColSettings.vue?vue&type=template&id=2a83f20a"
import script from "./leftColSettings.vue?vue&type=script&lang=js"
export * from "./leftColSettings.vue?vue&type=script&lang=js"
import style0 from "./leftColSettings.vue?vue&type=style&index=0&id=2a83f20a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports